import type { Event, AddBasketOfferPurchaseData } from '@ori-events/add-basket-offer';

export const isAddBasketOfferPurchaseEvent = (
  event: Event,
): event is Event<AddBasketOfferPurchaseData> => Boolean(event.detail.items);
